import React from "react";

type State = { hasError: boolean };

/**
 * After a deploy, users holding an old index.html can hit ChunkLoadError when
 * a lazy route requests a hashed chunk that no longer exists. Prompt a reload
 * instead of white-screening.
 */
class ChunkErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "48px 24px", textAlign: "center", fontFamily: "system-ui, sans-serif" }}>
          <p style={{ marginBottom: 16 }}>
            This page failed to load — the app may have been updated since you opened it.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "8px 20px",
              border: "1px solid #0B6B56",
              background: "#0B6B56",
              color: "#F5FAF7",
              borderRadius: 3,
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
